import axios from 'axios';
import { store } from '@/store'

const instance = axios.create({
    baseURL: store.state.global.urlApi,
    'api-version': '1.0',
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    },
    timeout: 8000
});

instance.interceptors.request.use(
    (config) => {
        if (config.url != '/VersionInfo' &&
            config.url != '/Login' &&
            config.url != '/Faqs') {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user && user.token) {
                config.headers['Authorization'] = user.token;
            }
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Intercept all responses
instance.interceptors.response.use(
    (response) => {
        return response;
    },

    (error) => {
        console.log(error)
        if (!!error && !!error.response && !!error.response.status) {
            if (error.response.status == 401) {
                const { dispatch } = store;
                dispatch("authentication/logout");
            }
        }
        return Promise.reject(error);
    }
);


export default instance;
